<div class="inner-header-hotline" title="Hotline" (click)="requestSupport()">
    <div>
        <i class="fal fa-fw fa-lg fa-user-headset" aria-hidden="true"></i>
    </div>
</div>
